import { FC, ReactNode } from 'react'

import { Box } from '@mui/material'

import { GameRef, GenreTaxonomy } from '../../types'
import { CreativeAdNetworkSelector } from '../CreativeAdNetworkSelector/CreativeAdNetworkSelector'
import { UAInsightsGenreSelector } from '../UAInsightsGenreSelector/UAInsightsGenreSelector'
import { UAInsightsMonthSelector } from '../UAInsightsMonthSelector/UAInsightsMonthSelector'
import { UAInsightsSearchBar } from '../UAInsightsSearchBar/UAInsightsSearchBar'

interface UAInsightsHeaderBarProps {
  games: GameRef[]
  genres: GenreTaxonomy[]
  onSelectGame: (gameId: string) => void
  onSelectGenre: (genreId: string) => void
  /** Optional breadcrumb pinned to the bottom of the sticky header (detail views only). */
  breadcrumb?: ReactNode
}

export const UAInsightsHeaderBar: FC<UAInsightsHeaderBarProps> = ({ games, genres, onSelectGame, onSelectGenre, breadcrumb }) => (
  <Box
    sx={{
      position: 'sticky',
      top: '95px',
      zIndex: 50,
      isolation: 'isolate',
      bgcolor: 'background.default',
      pt: 1.5,
      pb: 1.5,
      mt: -2.3,
      mb: 1,
      width: '100%',
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%', flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
      <CreativeAdNetworkSelector sx={{ flexShrink: 0 }} />
      <UAInsightsMonthSelector sx={{ flexShrink: 0 }} />
      <UAInsightsGenreSelector sx={{ flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <UAInsightsSearchBar games={games} genres={genres} onSelectGame={onSelectGame} onSelectGenre={onSelectGenre} />
      </Box>
    </Box>
    {breadcrumb && <Box sx={{ mt: 1.5 }}>{breadcrumb}</Box>}
  </Box>
)
